<script lang="ts">
    import {datatypes} from 'src/typings';
    import {LabeledValue} from 'src/features/erp-sutor/shared';
    import type {RecordDetailField} from './types';
    import {
        hasOriginRecordReference,
        isErrorGridFieldValue,
        isOptionGridFieldValue
    } from 'src/features/record-grid/lib/types-utils';
    import {
        isGridFieldDetailField,
        isValidRecordDetailField,
        isCustomValueDetailField,
        isCustomComponentDetailField
    } from './utils';
    import {exists} from 'shared/utils/custom-utils';
    import ErrorFieldValue from 'src/features/record-grid/components/cells/data-cell/values/ErrorFieldValue.svelte';
    import OptionFieldValue from 'src/features/record-grid/components/cells/data-cell/values/OptionFieldValue.svelte';
    import ScalarFieldValue from 'src/features/record-grid/components/cells/data-cell/values/ScalarFieldValue.svelte';
    import ReferenceFieldValue from 'src/features/record-grid/components/cells/data-cell/values/ReferenceFieldValue.svelte';

    export let detailField: RecordDetailField;

    if (!isValidRecordDetailField(detailField)) {
        throw new Error(`Invalid record detail field provided: ${JSON.stringify(detailField)}`);
    }
</script>

<LabeledValue additionalClasses="record-detail-grid-field"
              label={detailField.text ?? 'unknown'}
              withoutBiggerValueText>

    {#if isGridFieldDetailField(detailField)}
        {@const field = detailField.field}
        {@const fieldType = detailField.definition}

        {#if !exists(field)}
            -
        {:else if hasOriginRecordReference(field) && fieldType.valueDatatype?.name === datatypes.TEXT}
            <ReferenceFieldValue value={field}/>
        {:else if isErrorGridFieldValue(field)}
            <ErrorFieldValue value={field}/>
        {:else if isOptionGridFieldValue(field)}
            <OptionFieldValue value={field}/>
        {:else}
            <ScalarFieldValue value={field}
                              valueFormat={fieldType.valueFormat}
                              datatype={fieldType.valueDatatype}/>
        {/if}
    {/if}

    {#if isCustomValueDetailField(detailField)}
        {@const value = detailField.value}

        {value}
    {/if}

    {#if isCustomComponentDetailField(detailField)}
        {@const component = detailField.component}
        {@const props = detailField.props}

        <svelte:component this={component} {...props}/>
    {/if}
</LabeledValue>

<style lang="less">
    :global {
        .record-detail-grid-field .value {
            width: 100%;
        }
    }
</style>
